import moment from 'moment-timezone/moment-timezone';

import { MOMENT_PST_ZONE } from 'constants/appConstants';

export default function setupMomentTimezone() {
  // Initialize moment-timezone
  moment.tz.add(MOMENT_PST_ZONE);
  moment.tz.link('America/Los_Angeles|US/Pacific');
}
